// MUST_MATCH_AGENT: scheme, host, and path allowlist must stay synchronized
// with ALLOWED_NAVIGATE_PATHS in agent/src-tauri/src/url_listener/url_callback.rs
const AGENT_DEEP_LINK_SCHEME = "controla";
const AGENT_DEEP_LINK_HOST = "navigate";
const AGENT_DEEP_LINK_PATHS = ["/integrations", "/tasks"] as const;

export type AgentDeepLinkPath = (typeof AGENT_DEEP_LINK_PATHS)[number];

export function isAgentDeepLinkPath(path: string): path is AgentDeepLinkPath {
  return (AGENT_DEEP_LINK_PATHS as readonly string[]).includes(path);
}

export function buildAgentNavigateUrl(
  path: AgentDeepLinkPath,
  queryParams: Record<string, string>,
): string {
  const url = new URL(
    `${AGENT_DEEP_LINK_SCHEME}://${AGENT_DEEP_LINK_HOST}${path}`,
  );
  for (const [key, value] of Object.entries(queryParams)) {
    url.searchParams.set(key, value);
  }
  return url.toString();
}
